<template>
  <div class="main-content">
    <div class="section__content section__content--p30">
      <div class="container-fluid">
        <v-card max-width="1024" class="p-b-15 m-b-40">
          <v-card-title class="headline">
            <v-btn
              text icon
              class="m-0"
              @click="$router.back()">
              <i class="zmdi zmdi-long-arrow-left"></i>
            </v-btn>
            {{ text('change_password_header') }}
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="form.currentPassword"
              :append-icon="showCurrentPassword ? 'visibility' : 'visibility_off'"
              :type="showCurrentPassword ? 'text' : 'password'"
              name="current-password"
              autocomplete="current-password"
              :label="text('current_password')"
              :rules="[rules.required]"
              counter
              @click:append="showCurrentPassword = !showCurrentPassword">
            </v-text-field>
            <v-text-field
              v-model="form.newPassword"
              :append-icon="showNewPassword ? 'visibility' : 'visibility_off'"
              :rules="[rules.required, rules.min]"
              :type="showNewPassword ? 'text' : 'password'"
              name="new-password"
              autocomplete="new-password"
              :label="text('new_password')"
              counter
              @click:append="showNewPassword = !showNewPassword">
            </v-text-field>
            <v-text-field
              v-model="form.confirmedPassword"
              :append-icon="showConfirmedPassword ? 'visibility' : 'visibility_off'"
              :rules="[rules.required, rules.min]"
              :type="showConfirmedPassword ? 'text' : 'password'"
              name="confirmed-password"
              autocomplete="new-password"
              :label="text('confirm_new_password')"
              counter
              @click:append="showConfirmedPassword = !showConfirmedPassword">
            </v-text-field>
            <small class="help-block form-text text-danger m-t-0"
                   v-if="form.newPassword.length >= 6 && form.confirmedPassword.length >= 6 && form.newPassword !== form.confirmedPassword">
              {{ text('passwords_not_match_err') }}
            </small>
          </v-card-text>
          <v-card-actions class="text-right m-r-10">
            <v-spacer/>
            <v-btn
              :disabled="!isFormValid"
              color="success"
              @click="onSubmit">
              {{ text('change_password_btn') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmedPassword: false,
      form: {
        currentPassword: '',
        newPassword: '',
        confirmedPassword: '',
      },
      rules: {
        required: value => !!value || this.text('non_empty_err'),
        min: v => v.length >= 6 || this.text('password_min_len_err'),
      },
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    isFormValid() {
      return this.form.currentPassword.length > 1
        && this.form.newPassword.length >= 6
        && this.form.confirmedPassword.length >= 6
        && this.form.newPassword === this.form.confirmedPassword;
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    onSubmit() {
      const formData = {
        oldPassword: this.form.currentPassword,
        newPassword: this.form.newPassword,
      };

      this.$store.dispatch('changeMyPassword', formData)
        .then(() => {
          this.$toasted.success(this.text('password_change_popup'), {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.$router.push({ name: 'ProfileInfoPage' });
        })
        .catch((errorMsg) => {
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
